export const ANIMATIONS = {
  in: 400,
  out: 300,
}
